import styles from './FJCommon.module.less';
import FJYoutubeContainer from '@src/components/FJModals/FJShareModal/FJShareContent/target/FJYoutubeContainer.tsx';
import FJButton, { FJButtonType } from '@src/common/components/FJButton/FJButton.tsx';
import FJLocalStore from '@src/store/FJLocalStore';
import { useAppDispatch, useAppSelector } from '@src/redux/hooks.ts';
import { FJModalsAction } from '@src/redux/action/FJModalsAction.ts';
import FJPublishAction from '@src/redux/action/FJPublishAction.ts';
import FJLinkedinContainer from '@src/components/FJModals/FJShareModal/FJShareContent/target/FJLinkedinContainer.tsx';

const FJPublishSetting = () => {
    const dispatch = useAppDispatch();
    const selectedShareTypes = useAppSelector(state => state.share.selectedShareTypes);
    const onClose = () => {
        dispatch(FJModalsAction.hideShareModalAction('cancel'));
    };
    const publish = () => {
        dispatch(FJPublishAction.publishAction());
    };

    const isEmpty = selectedShareTypes.length === 0;

    return (
        <div className={styles.box}>
            <div className={styles.content}>
                <div className={styles.item_list}>
                    <FJYoutubeContainer />
                    <FJLinkedinContainer />
                    {/*<FJTiktokContainer />*/}
                </div>
                {isEmpty && (
                    <div className={styles.empty_selected}>{FJLocalStore._('At least select one account')}</div>
                )}
            </div>
            <div className={styles.foot}>
                <FJButton
                    className={styles.button}
                    text={FJLocalStore._('cancel')}
                    type={FJButtonType.DEFAULT}
                    onClick={onClose}
                />
                <FJButton
                    className={styles.button}
                    text={FJLocalStore._('publish')}
                    type={FJButtonType.GRADIENT}
                    onClick={publish}
                    disabled={isEmpty}
                />
            </div>
        </div>
    );
};

export default FJPublishSetting;
